import { useTranslation } from 'react-i18next';
import { Grid } from '@shared/ui';

import { SectionHeader } from './SectionHeader';
import { BreadcrumbShowcase } from './navigation/BreadcrumbShowcase';
import { PaginationShowcase } from './navigation/PaginationShowcase';
import { TabsShowcase } from './navigation/TabsShowcase';
import { ViewModeTabsShowcase } from './navigation/ViewModeTabsShowcase';

export function NavigationSection() {
  const { t } = useTranslation();

  return (
    <section id="navigation" className="space-y-6">
      <SectionHeader
        title={t('uiLibrary.navigation.title')}
        description={t('uiLibrary.navigation.description')}
      />

      <Grid cols={1} gap="lg" className="lg:grid-cols-2">
        <TabsShowcase />
        <ViewModeTabsShowcase />
        <BreadcrumbShowcase />
        <div className="lg:col-span-2">
          <PaginationShowcase />
        </div>
      </Grid>
    </section>
  );
}
